module.exports = __webpack_public_path__ + "img/autospin_btn.e7f3f9e1.png";